  <div class="parent bg-[#F1F1F9]">
    <div class="flex-container" *ngIf="step == 0" >
      <div *ngIf="hideHeader" style="flex: 1" class="hero flex flex-col items-center justify-center text-center gap-4 py-8">
        <div class="w-56 bh-56 rounded-full flex items-center justify-center">
          <svg width="57" height="56" viewBox="0 0 57 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.3301 18.3112L22.8056 21.9616L28.2641 14.3196C28.6827 13.7336 29.4971 13.5978 30.0831 14.0164C30.2002 14.1001 30.3026 14.2025 30.3863 14.3196L35.8449 21.9616L41.3203 18.3112C41.9196 17.9117 42.7291 18.0737 43.1286 18.6729C43.3003 18.9305 43.3748 19.2409 43.3386 19.5485L41.196 37.761C41.1187 38.4177 40.5622 38.9125 39.901 38.9125H18.7494C18.0882 38.9125 17.5317 38.4177 17.4544 37.761L15.3118 19.5485C15.2276 18.8333 15.7392 18.1853 16.4544 18.1011C16.762 18.065 17.0724 18.1394 17.3301 18.3112ZM29.3253 31.089C30.7655 31.089 31.9331 29.9214 31.9331 28.4811C31.9331 27.0409 30.7655 25.8733 29.3253 25.8733C27.885 25.8733 26.7174 27.0409 26.7174 28.4811C26.7174 29.9214 27.885 31.089 29.3253 31.089Z" fill="#7700EE"/>
          </svg>
        </div>
        <h2 *ngIf="hideHeader" class="text-2xl ont-semibold text-gray-900">Like this feature?</h2>
        <p class="text-xl text-gray-700 max-w-md">Get <b>Premium</b> now so you can<br/>keep enjoying it!</p>
      </div>
      <div class="flex items-center h-full px-4 sm:px-12 lg:px-18">
        <app-chat-subscription-select (onProceedToPayment)="proceedToPayment($event)"></app-chat-subscription-select>
      </div>
    </div>
    <!-- Step 1: Payment Details -->
    <div *ngIf="step == 1"
         class="flex-container md:w-[470px] m-auto lg:h-min md:h-screen sm:h-screen no-scrollbar pb-4 pt-4 overflow-y-auto">
      <div class="payment-form account-library-details">
        <app-popup-subscription-details
          class=""
          [subscription]="selectedSubscription"
          [user]="user"
        ></app-popup-subscription-details>
      </div>
      <div class="payment-form account-library-details">
        <app-popup-card-details
          class="full-width"
          [subscription]="selectedSubscription"
          [user]="user"
          (onPaymentSuccess)="success()"
        ></app-popup-card-details>
      </div>
    </div>
    <div *ngIf="step == 2">
      <app-popup-processing class="payment-processing"></app-popup-processing>
    </div>
  </div>
